import React from "react";
import './Pipeline.css'
import frameworkImage1 from "../../utils/assets/images/framework1.png"
import frameworkImage2 from "../../utils/assets/images/framework2.png"
import frameworkImage3 from "../../utils/assets/images/framework3.png"
import frameworkImage4 from "../../utils/assets/images/framework4.png"
import frameworkImage5 from "../../utils/assets/images/framework5.png"
import frameworkImage6 from "../../utils/assets/images/framework6.png"
import frameworkImage7 from "../../utils/assets/images/framework7.png"
import frameworkImage8 from "../../utils/assets/images/framework8.png"
import frameworkImage9 from "../../utils/assets/images/framework9.png"
import frameworkImage10 from "../../utils/assets/images/framework10.png"
import frameworkImage11 from "../../utils/assets/images/framework11.png"
import frameworkImage12 from "../../utils/assets/images/framework12.png"
import frameworkImage13 from "../../utils/assets/images/framework13.png"
import frameworkImage14 from "../../utils/assets/images/framework14.png"
import frameworkImage15 from "../../utils/assets/images/framework15.png"
import frameworkImage16 from "../../utils/assets/images/framework16.png"
import frameworkImage17 from "../../utils/assets/images/framework17.png"
import frameworkImage18 from '../../utils/assets/images/mous1.png'
import frameworkImage19 from '../../utils/assets/images/mous3.png'
import frameworkImage20 from '../../utils/assets/images/mous4.png'
import frameworkImage21 from '../../utils/assets/images/mous5.png'
import frameworkImage22 from '../../utils/assets/images/mous6.png'
import mous1 from '../../utils/assets/images/mous-1.png'
import mous2 from '../../utils/assets/images/mous2.jpg'
import mous3 from '../../utils/assets/images/mous3.jpg'
import mous4 from '../../utils/assets/images/mous4.jpg'
import mous5 from '../../utils/assets/images/mous-5.png'
import mous6 from '../../utils/assets/images/mous-6.png'
import mous7 from '../../utils/assets/images/mous7.png'
import mous8 from '../../utils/assets/images/mous8.png'
import mous9 from '../../utils/assets/images/mous-9.png'
import mous10 from '../../utils/assets/images/mous-10.jpg'
const PipelineSection = () => {
    return (
        <>
            <div className="pipeline-container" id='pipeline'>
                <div className="tilte-bg-wrapper">
                    <div className="pipeline-content-bg"></div>
                    <div className="pipeline-content">
                        <div className="pipeline-content-title">
                            <div></div>
                            <div className="pipeline-content-title">
                                Egypt has 23 valid MoUs. To date , 15 binding framework agreements have been successfully signed.
                            </div>
                            {/* <div className="pipeline-content-title">Egypt has 20 active MoUs to date of which 11 projects have successfully reached Framework Agreements</div> */}
                        </div>
                    </div>
                </div>
                <div className='pipeline-section'  >

                    <div className="ctr">
                        <div className="pipeline-title">
                            Pipeline
                        </div>
                        <div className="framework-wrapper">
                            <div className="framework-wrapper-title">
                                Framework Agreements
                            </div>
                            <div className="framworks-row row-1 row mt-5">

                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage1} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage2} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage15} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col" >
                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col">


                                        <div className="first-image ">
                                            <img src={frameworkImage7} />
                                            <img src={frameworkImage12} />
                                        </div>
                                        <div className="first-image first-col"><img src={frameworkImage16} />  <img src={frameworkImage13} /></div>
                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>
                            </div>
                            <div className="framworks-row row-2 row mt-3">

                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage17} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col" >
                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col-block">
                                        <div className="first-image"><img src={frameworkImage8} /></div>
                                        <div className="second-image"><img src={frameworkImage14} /></div>
                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col" >
                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col">
                                        <div className="first-image"><img src={frameworkImage11} /></div>
                                        <div className="second-image">
                                            <img src={frameworkImage4} /></div>

                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col" >
                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col">
                                        <div className="first-image">
                                            <img src={frameworkImage19} />
                                        </div>
                                        <div className="second-image">
                                            <img src={frameworkImage20} />
                                        </div>
                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>
                            </div>
                            <div className="framworks-row row-3 row mt-3">

                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage10} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage5} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage6} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col" >
                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col">
                                        <div className="first-image"><img src={frameworkImage9} /></div>
                                        <div className="second-image">
                                            <img src={frameworkImage3} />
                                        </div>

                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>
                            </div>

                            <div className="framworks-row row-4 row mt-4">

                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage18} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage22} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5" >
                                    <img src={frameworkImage21} />
                                </div>
                                <div className="framwork-image col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col" >

                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="mous-wrapper">
                            <div className="mous-wrapper-title  mt-5">
                                MoUs
                            </div>
                            <div className="mous-row row pt-5">
                                {/* {moUs?.map(item => (

                                    <div className="mous-image mb-4" key={item?.id}>
                                        <img src={item?.image} />
                                    </div>
                                ))} */}
                                <div className="col-lg-3 col-md-3 col-12 mb-5 mous-col">  <img  src={mous1} /></div>
                                <div className="col-lg-3 col-md-3 col-12 mb-5  mous-col">  <img style={{width:"45%"}} src={mous2} /></div>
                                <div className="col-lg-3 col-md-3 col-12 mb-5  mous-col">  <img src={mous3} /></div>
                                <div className=" col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col">
                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col">
                                        <div className="first-image mous-images">
                                            <img src={mous4} />
                                        </div>
                                        <div className="second-image ">
                                            <img src={mous5} />
                                        </div>
                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-12 mb-5  mous-col">  <img src={mous6} /></div>
                                <div className="col-lg-3 col-md-3 col-12 mb-5  mous-col">  <img src={mous7} /></div>
                                <div className="col-lg-3 col-md-3 col-12 mb-5  mous-col">  <img src={mous8} /></div>
                                <div className=" col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-5 group-image-col">

                                    <div className="start-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M0 1H30V24" stroke="#000" />
                                    </svg></div>
                                    <div className="two-image-col">
                                        <div className="first-image mous-images">
                                            <img src={mous9} />
                                        </div>
                                        <div className="second-image">
                                            <img src={mous10} />
                                        </div>
                                    </div>
                                    <div className="end-symbole"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none">
                                        <path d="M31 23H1V0" stroke="#000" />
                                    </svg></div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
export default PipelineSection